"use client"

import { GridLayout } from "@/app/grid"
import type { Drop } from "@anaconda/core/drop/types"
import { DropItem } from "./drop-item"

interface DropsListProps {
  drops: Drop[]
}

export function DropsList({ drops }: DropsListProps) {
  return (
    <div data-testid="drops-grid-view">
      <GridLayout>
        {drops.map((drop) => (
          <DropItem key={drop.id} drop={drop} />
        ))}
      </GridLayout>
    </div>
  )
}
